export const VILLAGE_ZOOM_ARR = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
export const POP_POPUP = {
  head: 'Население',
  fields: [
    {label: 'Местоположение', value: 'name_with_type'},
    {label: 'Население, человек', value: 'population'}
  ]
}
export const FORMED_POPUP = {
  head: 'Образовано отходов',
  fields: [
    {label: 'Местоположение', value: 'name_with_type'},
    {label: 'Количество, тонн', value: 'formed'}
  ]
}
export const RECYCLE_POPUP = {
  head: 'Пеработанно отходов',
  fields: [
    {label: 'Местоположение', value: 'name_with_type'},
    {label: 'Количество, тонн', value: 'recycle'}
  ]
}
export const TOMB_POPUP = {
  head: 'Количество захоронений',
  fields: [
    {label: 'Местоположение', value: 'name_with_type'},
    {label: 'Количество, тонн', value: 'tomb'}
  ]
}

export const DEFAULT_OPACITY = 0.6
export const ZONES = 'zones'
export const DEFAULT_REGION_BORDER_COLOR = '#c7c5c0'
